import type { TableColumns } from '@ohpen/enso-ui';
import { FieldType } from '@pmp/api';
import { ProductData } from '@pmp/types';

export const productsColumns: TableColumns<ProductData> = [
  {
    title: 'pmp.products.labels.code',
    dataIndex: 'code',
    key: 'code',
    width: 130,
    fixed: 'left',
    options: {
      filter: 'search',
      sorter: true,
      required: true,
    },
  },
  {
    title: 'pmp.products.labels.name',
    dataIndex: 'name',
    key: 'name',
    width: 180,
    options: {
      filter: 'search',
      sorter: true,
      required: true,
    },
  },
  {
    title: 'pmp.products.labels.group',
    dataIndex: 'group',
    key: 'group',
    width: 110,
    options: {
      filter: 'search',
      hide: true,
    },
  },
  {
    title: 'pmp.products.labels.initialRateTypeId',
    dataIndex: 'initialRateType',
    key: 'initialRateTypeId',
    width: 120,
    options: {
      format: {
        type: 'valueListKey',
      },
      filter: 'select',
      listName: FieldType.INITIAL_RATE_TYPE,
      hide: true,
      hideInForm: true,
    },
  },
  {
    title: 'pmp.products.labels.initialRateType',
    dataIndex: 'initialRateType',
    key: 'initialRateType',
    width: 120,
    options: {
      format: {
        type: 'valueList',
      },
      filter: 'select',
      listName: FieldType.INITIAL_RATE_TYPE,
    },
  },
  {
    title: 'pmp.products.labels.applicationTypeIds',
    dataIndex: 'applicationTypes',
    key: 'applicationTypeIds',
    width: 130,
    options: {
      format: {
        type: 'multiValueListKey',
      },
      filter: 'select',
      listName: FieldType.APPLICATION_REQUEST_TYPE,
      hide: true,
      hideInForm: true,
    },
  },
  {
    title: 'pmp.products.labels.applicationTypes',
    dataIndex: 'applicationTypes',
    key: 'applicationTypes',
    width: 130,
    options: {
      format: {
        type: 'multiValueList',
      },
      filter: 'select',
      listName: FieldType.APPLICATION_REQUEST_TYPE,
    },
  },
  {
    title: 'pmp.products.labels.propertyPurposeId',
    dataIndex: 'propertyPurposes',
    key: 'propertyPurposeIds',
    width: 120,
    options: {
      format: {
        type: 'multiValueListKey',
      },
      filter: 'select',
      listName: FieldType.PROPERTY_PURPOSE,
      hide: true,
      hideInForm: true,
    },
  },
  {
    title: 'pmp.products.labels.propertyPurpose',
    dataIndex: 'propertyPurposes',
    key: 'propertyPurposes',
    width: 120,
    options: {
      format: {
        type: 'multiValueList',
      },
      filter: 'select',
      listName: FieldType.PROPERTY_PURPOSE,
    },
  },
  {
    title: 'pmp.products.labels.repaymentTypeIds',
    dataIndex: 'repaymentTypes',
    key: 'repaymentTypeIds',
    width: 150,
    options: {
      format: {
        type: 'multiValueListKey',
      },
      filter: 'select',
      listName: FieldType.REPAYMENT_TYPE,
      required: true,
      hide: true,
      hideInForm: true,
    },
  },
  {
    title: 'pmp.products.labels.repaymentTypes',
    dataIndex: 'repaymentTypes',
    key: 'repaymentTypes',
    width: 150,
    options: {
      format: {
        type: 'multiValueList',
      },
      filter: 'select',
      listName: FieldType.REPAYMENT_TYPE,
      required: true,
    },
  },
  {
    title: 'pmp.products.labels.expat',
    dataIndex: 'expat',
    key: 'expat',
    width: 120,
    options: {
      format: {
        type: 'boolean',
      },
      filter: 'select',
      listName: FieldType.YES_NO,
    },
  },
  {
    title: 'pmp.products.labels.minDurationInMonths',
    dataIndex: 'minDurationInMonths',
    key: 'minDurationInMonths',
    width: 110,
    options: {
      format: {
        type: 'number',
      },
      filter: 'number',
    },
  },
  {
    title: 'pmp.products.labels.maxDurationInMonths',
    dataIndex: 'maxDurationInMonths',
    key: 'maxDurationInMonths',
    width: 110,
    options: {
      format: {
        type: 'number',
      },
      filter: 'number',
    },
  },
  {
    title: 'pmp.products.labels.productTermId',
    dataIndex: 'productTerm',
    key: 'productTermId',
    width: 120,
    options: {
      format: {
        type: 'valueListKey',
      },
      filter: 'select',
      listName: FieldType.PRODUCT_TERM,
      hide: true,
      hideInForm: true,
    },
  },
  {
    title: 'pmp.products.labels.productTerm',
    dataIndex: 'productTerm',
    key: 'productTerm',
    width: 120,
    options: {
      format: {
        type: 'valueList',
      },
      filter: 'select',
      listName: FieldType.PRODUCT_TERM,
    },
  },
  {
    title: 'pmp.products.labels.initialPeriodInMonths',
    dataIndex: 'initialPeriodInMonths',
    key: 'initialPeriodInMonths',
    width: 120,
    options: {
      format: {
        type: 'number',
      },
      filter: 'number',
    },
  },
  {
    title: 'pmp.products.labels.initialPeriodUntil',
    dataIndex: 'initialPeriodUntil',
    key: 'initialPeriodUntil',
    width: 120,
    options: {
      format: {
        type: 'date',
      },
      filter: 'date',
    },
  },
  {
    title: 'pmp.products.labels.minTotalLoanAmount',
    dataIndex: 'minTotalLoanAmount',
    key: 'minTotalLoanAmount',
    width: 120,
    options: {
      format: {
        type: 'currency',
        decimalScale: 0,
      },
      filter: 'number',
    },
  },
  {
    title: 'pmp.products.labels.maxTotalLoanAmount',
    dataIndex: 'maxTotalLoanAmount',
    key: 'maxTotalLoanAmount',
    width: 120,
    options: {
      format: {
        type: 'currency',
        decimalScale: 0,
      },
      filter: 'number',
    },
  },
  {
    title: 'pmp.products.labels.minLtv',
    dataIndex: 'minLtv',
    key: 'minLtv',
    width: 120,
    options: {
      format: {
        type: 'percentage',
        decimalScale: 2,
      },
      filter: 'number',
    },
  },
  {
    title: 'pmp.products.labels.maxLtv',
    dataIndex: 'maxLtv',
    key: 'maxLtv',
    width: 120,
    options: {
      format: {
        type: 'percentage',
        decimalScale: 2,
      },
      filter: 'number',
    },
  },
  {
    title: 'pmp.products.labels.maxLti',
    dataIndex: 'maxLti',
    key: 'maxLti',
    width: 120,
    options: {
      format: {
        type: 'percentage',
        decimalScale: 2,
      },
      filter: 'number',
    },
  },
  {
    title: 'pmp.products.labels.baseRateId',
    dataIndex: 'baseRate',
    key: 'baseRateId',
    width: 120,
    options: {
      format: {
        type: 'valueListKey',
      },
      filter: 'select',
      listName: FieldType.BASE_RATES,
      hide: true,
      hideInForm: true,
    },
  },
  {
    title: 'pmp.products.labels.baseRateName',
    dataIndex: 'baseRate',
    key: 'baseRateName',
    width: 120,
    options: {
      format: {
        type: 'valueList',
      },
      allowSearch: true,
      filter: 'select',
      listName: FieldType.BASE_RATES,
    },
  },
  {
    title: 'pmp.products.labels.ercProfileId',
    dataIndex: 'ercProfile',
    key: 'ercProfileId',
    width: 120,
    options: {
      format: {
        type: 'valueListKey',
      },
      filter: 'select',
      listName: FieldType.ERC_PROFILES,
      hide: true,
      hideInForm: true,
    },
  },
  {
    title: 'pmp.products.labels.ercProfileName',
    dataIndex: 'ercProfile',
    key: 'ercProfileName',
    width: 150,
    options: {
      format: {
        type: 'valueList',
      },
      allowSearch: true,
      filter: 'select',
      listName: FieldType.ERC_PROFILES,
    },
  },
  {
    title: 'pmp.products.labels.baseRate',
    dataIndex: 'baseRateAmount',
    key: 'baseRateAmount',
    width: 120,
    options: {
      format: {
        type: 'percentage',
        decimalScale: 2,
      },
      filter: 'number',
      hideInForm: true,
    },
  },
  {
    title: 'pmp.products.labels.surcharge',
    dataIndex: 'surcharge',
    key: 'surcharge',
    width: 120,
    options: {
      format: {
        type: 'percentage',
        decimalScale: 2,
      },
      filter: 'number',
    },
  },
  {
    title: 'pmp.products.labels.rate',
    dataIndex: 'rate',
    key: 'rate',
    width: 120,
    options: {
      format: {
        type: 'percentage',
        decimalScale: 2,
        // fixedDecimalScale: true,
      },
      filter: 'number',
      hideInForm: true,
    },
  },
  {
    title: 'pmp.products.labels.stressRate',
    dataIndex: 'stressRate',
    key: 'stressRate',
    width: 120,
    options: {
      format: {
        type: 'percentage',
        decimalScale: 2,
      },
      filter: 'number',
    },
  },
  {
    title: 'pmp.products.labels.followingProductCode',
    dataIndex: 'followingProductCode',
    key: 'followingProductCode',
    width: 120,
    options: {
      filter: 'search',
    },
  },
  {
    title: 'pmp.products.labels.cashback',
    dataIndex: 'cashback',
    key: 'cashback',
    width: 120,
    options: {
      format: {
        type: 'currency',
        decimalScale: 0,
      },
      filter: 'number',
    },
  },
  {
    title: 'pmp.products.labels.feesAssisted',
    dataIndex: 'feesAssisted',
    key: 'feesAssisted',
    width: 120,
    options: {
      format: {
        type: 'boolean',
      },
      filter: 'select',
      listName: FieldType.YES_NO,
    },
  },
  {
    title: 'pmp.products.labels.freeValuation',
    dataIndex: 'freeValuation',
    key: 'freeValuation',
    width: 120,
    options: {
      format: {
        type: 'boolean',
      },
      filter: 'select',
      listName: FieldType.YES_NO,
    },
  },
  {
    title: 'pmp.products.labels.feeProfileId',
    dataIndex: 'feeProfile',
    key: 'feeProfileId',
    width: 120,
    options: {
      format: {
        type: 'valueListKey',
      },
      filter: 'select',
      listName: FieldType.FEE_PROFILES,
      hide: true,
      hideInForm: true,
    },
  },
  {
    title: 'pmp.products.labels.feeProfileName',
    dataIndex: 'feeProfile',
    key: 'feeProfileName',
    width: 120,
    options: {
      format: {
        type: 'valueList',
      },
      allowSearch: true,
      filter: 'select',
      listName: FieldType.FEE_PROFILES,
    },
  },
  {
    title: 'pmp.products.labels.brandIds',
    dataIndex: 'brands',
    key: 'brandIds',
    width: 120,
    options: {
      format: {
        type: 'multiValueListKey',
      },
      filter: 'select',
      listName: FieldType.BRANDS,
      hide: true,
      hideInForm: true,
    },
  },
  {
    title: 'pmp.products.labels.brands',
    dataIndex: 'brands',
    key: 'brands',
    width: 120,
    options: {
      format: {
        type: 'multiValueList',
      },
      filter: 'select',
      listName: FieldType.BRANDS,
      hide: true,
    },
  },
  {
    title: 'pmp.products.labels.employmentTypeId',
    dataIndex: 'employmentType',
    key: 'employmentTypeId',
    width: 120,
    options: {
      format: {
        type: 'valueListKey',
      },
      filter: 'select',
      listName: FieldType.EMPLOYMENT_TYPE,
      hide: true,
      hideInForm: true,
    },
  },
  {
    title: 'pmp.products.labels.employmentType',
    dataIndex: 'employmentType',
    key: 'employmentType',
    width: 120,
    options: {
      format: {
        type: 'valueList',
      },
      filter: 'select',
      listName: FieldType.EMPLOYMENT_TYPE,
      hide: true,
    },
  },
  {
    title: 'pmp.products.labels.applicantTypes',
    dataIndex: 'applicantTypes',
    key: 'applicantTypes',
    width: 150,
    options: {
      format: {
        type: 'multiValueList',
      },
      filter: 'select',
      listName: FieldType.APPLICANT_TYPES,
    },
  },
  {
    title: 'pmp.products.labels.applicantTypeIds',
    dataIndex: 'applicantTypes',
    key: 'applicantTypeIds',
    width: 130,
    options: {
      format: {
        type: 'multiValueListKey',
      },
      filter: 'select',
      listName: FieldType.APPLICANT_TYPES,
      hide: true,
      hideInForm: true,
    },
  },
  {
    title: 'pmp.products.labels.startDate',
    dataIndex: 'startDate',
    key: 'startDate',
    width: 120,
    options: {
      format: {
        type: 'date',
      },
      filter: 'date',
      sorter: true,
    },
  },
  {
    title: 'pmp.products.labels.endDate',
    dataIndex: 'endDate',
    key: 'endDate',
    width: 120,
    options: {
      format: {
        type: 'date',
      },
      filter: 'date',
      sorter: true,
    },
  },
  {
    title: 'pmp.products.labels.gracePeriodEndDate',
    dataIndex: 'gracePeriodEndDate',
    key: 'gracePeriodEndDate',
    width: 140,
    options: {
      format: {
        type: 'date',
      },
      filter: 'date',
      sorter: true,
      hide: true,
    },
  },
  {
    title: 'pmp.products.labels.productCutoffDate',
    dataIndex: 'productCutoffDate',
    key: 'productCutoffDate',
    width: 120,
    options: {
      format: {
        type: 'date',
      },
      filter: 'date',
      hide: true,
    },
  },
  {
    title: 'pmp.products.labels.productFeePoundsOverride',
    dataIndex: 'productFeePoundsOverride',
    key: 'productFeePoundsOverride',
    width: 120,
    options: {
      format: {
        type: 'currency',
        decimalScale: 0,
      },
      filter: 'number',
    },
  },
  {
    title: 'pmp.products.labels.applicationFeeOverride',
    dataIndex: 'applicationFeeOverride',
    key: 'applicationFeeOverride',
    width: 120,
    options: {
      format: {
        type: 'currency',
        decimalScale: 0,
      },
      filter: 'number',
    },
  },
  {
    title: 'pmp.products.labels.personOrCompanyId',
    dataIndex: 'personOrCompany',
    key: 'personOrCompanyId',
    width: 120,
    options: {
      format: {
        type: 'valueListKey',
      },
      filter: 'select',
      listName: FieldType.PERSON_OR_COMPANY,
      hide: true,
      hideInForm: true,
    },
  },
  {
    title: 'pmp.products.labels.personOrCompany',
    dataIndex: 'personOrCompany',
    key: 'personOrCompany',
    width: 120,
    options: {
      format: {
        type: 'valueList',
      },
      filter: 'select',
      listName: FieldType.PERSON_OR_COMPANY,
    },
  },
  {
    title: 'pmp.products.labels.occupancyTypeIds',
    dataIndex: 'occupancyTypes',
    key: 'occupancyTypeIds',
    width: 130,
    options: {
      format: {
        type: 'multiValueListKey',
      },
      filter: 'select',
      listName: FieldType.OCCUPANCY_TYPE,
      hide: true,
      hideInForm: true,
    },
  },
  {
    title: 'pmp.products.labels.occupancyTypes',
    dataIndex: 'occupancyTypes',
    key: 'occupancyTypes',
    width: 130,
    options: {
      format: {
        type: 'multiValueList',
      },
      filter: 'select',
      listName: FieldType.OCCUPANCY_TYPE,
    },
  },
  {
    title: 'pmp.products.labels.schemes',
    dataIndex: 'schemes',
    key: 'schemes',
    width: 130,
    options: {
      format: {
        type: 'multiValueList',
      },
      filter: 'select',
      listName: FieldType.SCHEME,
    },
  },
  {
    title: 'pmp.products.labels.schemeIds',
    dataIndex: 'schemes',
    key: 'schemeIds',
    width: 130,
    options: {
      format: {
        type: 'multiValueListKey',
      },
      filter: 'select',
      listName: FieldType.SCHEME,
      hide: true,
      hideInForm: true,
    },
  },
  {
    title: 'pmp.products.labels.green',
    dataIndex: 'green',
    key: 'green',
    width: 120,
    options: {
      format: {
        type: 'boolean',
      },
      filter: 'select',
      listName: FieldType.YES_NO,
    },
  },
  {
    title: 'pmp.products.labels.replacesCode',
    dataIndex: 'replacesCode',
    key: 'replacesCode',
    width: 120,
    options: {
      filter: 'search',
    },
  },
  {
    title: 'pmp.products.labels.replacedByCode',
    dataIndex: 'replacedByCode',
    key: 'replacedByCode',
    width: 120,
    options: {
      filter: 'search',
    },
  },
  {
    title: 'pmp.products.labels.productFeePercentOverride',
    dataIndex: 'productFeePercentOverride',
    key: 'productFeePercentOverride',
    width: 120,
    options: {
      format: {
        type: 'percentage',
        decimalScale: 2,
      },
      filter: 'number',
    },
  },
  {
    title: 'pmp.products.labels.productFeeBasedOnOverride',
    dataIndex: 'productFeeBasedOnOverride',
    key: 'productFeeBasedOnOverride',
    width: 120,
    options: {
      format: {
        type: 'valueList',
      },
      filter: 'select',
      listName: FieldType.PRODUCT_FEE_BASED_ON,
    },
  },
  {
    title: 'pmp.products.labels.productFeeBasedOnOverrideId',
    dataIndex: 'productFeeBasedOnOverride',
    key: 'productFeeBasedOnOverrideId',
    width: 120,
    options: {
      format: {
        type: 'valueListKey',
      },
      filter: 'select',
      listName: FieldType.PRODUCT_FEE_BASED_ON,
      hide: true,
      hideInForm: true,
    },
  },
  {
    title: 'pmp.products.labels.buildingTypes',
    dataIndex: 'buildingTypes',
    key: 'buildingTypes',
    width: 120,
    options: {
      format: {
        type: 'multiValueList',
      },
      filter: 'select',
      listName: FieldType.BUILDING_TYPE,
      hide: true,
    },
  },
  {
    title: 'pmp.products.labels.buildingTypeIds',
    dataIndex: 'buildingTypes',
    key: 'buildingTypeIds',
    width: 120,
    options: {
      format: {
        type: 'multiValueListKey',
      },
      filter: 'select',
      listName: FieldType.BUILDING_TYPE,
      hide: true,
      hideInForm: true,
    },
  },
  {
    title: 'pmp.products.labels.regulatoryTypes',
    dataIndex: 'regulatoryTypes',
    key: 'regulatoryTypes',
    width: 120,
    options: {
      format: {
        type: 'multiValueList',
      },
      filter: 'select',
      listName: FieldType.REGULATORY_TYPE,
    },
  },
  {
    title: 'pmp.products.labels.regulatoryTypeIds',
    dataIndex: 'regulatoryTypes',
    key: 'regulatoryTypeIds',
    width: 120,
    options: {
      format: {
        type: 'multiValueListKey',
      },
      filter: 'select',
      listName: FieldType.REGULATORY_TYPE,
      hide: true,
      hideInForm: true,
    },
  },
  {
    title: 'pmp.products.labels.projectTypes',
    dataIndex: 'projectTypes',
    key: 'projectTypes',
    width: 120,
    options: {
      format: {
        type: 'multiValueList',
      },
      filter: 'select',
      listName: FieldType.PROJECT_TYPE,
    },
  },
  {
    title: 'pmp.products.labels.projectTypeIds',
    dataIndex: 'projectTypes',
    key: 'projectTypeIds',
    width: 120,
    options: {
      format: {
        type: 'multiValueListKey',
      },
      filter: 'select',
      listName: FieldType.PROJECT_TYPE,
      hide: true,
      hideInForm: true,
    },
  },
  {
    title: 'pmp.products.labels.propertyTypes',
    dataIndex: 'propertyTypes',
    key: 'propertyTypes',
    width: 120,
    options: {
      format: {
        type: 'multiValueList',
      },
      filter: 'select',
      listName: FieldType.PROPERTY_TYPE,
      hide: true,
    },
  },
  {
    title: 'pmp.products.labels.propertyTypeIds',
    dataIndex: 'propertyTypes',
    key: 'propertyTypeIds',
    width: 120,
    options: {
      format: {
        type: 'multiValueListKey',
      },
      filter: 'select',
      listName: FieldType.PROPERTY_TYPE,
      hide: true,
      hideInForm: true,
    },
  },
  {
    title: 'pmp.products.labels.portable',
    dataIndex: 'portable',
    key: 'portable',
    width: 120,
    options: {
      format: {
        type: 'boolean',
      },
      filter: 'select',
      listName: FieldType.YES_NO,
    },
  },
  {
    title: 'pmp.products.labels.overpaymentsAllowed',
    dataIndex: 'overpaymentsAllowed',
    key: 'overpaymentsAllowed',
    width: 120,
    options: {
      format: {
        type: 'percentage',
        decimalScale: 2,
      },
      filter: 'number',
    },
  },
  {
    title: 'pmp.products.labels.paymentsHoliday',
    dataIndex: 'paymentsHoliday',
    key: 'paymentsHoliday',
    width: 120,
    options: {
      format: {
        type: 'boolean',
      },
      filter: 'select',
      listName: FieldType.YES_NO,
    },
  },
  {
    title: 'pmp.products.labels.region',
    dataIndex: 'region',
    key: 'region',
    width: 120,
    options: {
      filter: 'search',
      hide: true,
    },
  },
  {
    title: 'pmp.products.labels.belongsToExclusivitySetIds',
    dataIndex: 'belongsToExclusivitySets',
    key: 'belongsToExclusivitySetIds',
    width: 120,
    options: {
      format: {
        type: 'multiValueListKey',
        ellipsis: true,
      },
      filter: 'select',
      listName: FieldType.EXCLUSIVITY_SETS,
      hide: true,
      hideInForm: true,
    },
  },
  {
    title: 'pmp.products.labels.belongsToExclusivitySets',
    dataIndex: 'belongsToExclusivitySets',
    key: 'belongsToExclusivitySets',
    width: 200,
    options: {
      format: {
        type: 'multiValueList',
        ellipsis: true,
      },
      allowSearch: true,
      filter: 'select',
      listName: FieldType.EXCLUSIVITY_SETS,
    },
  },
  {
    title: 'global.labels.actions',
    dataIndex: '',
    key: 'actions',
    width: 150,
    fixed: 'right',
    options: { hideInForm: true },
  },
];
